import React, { ComponentType } from 'react';
import { ChecklistMetricItem } from './handoff-checklist-v2/handoff-checklist-v2.types';
import { HandoffFlowProps } from './handoff-flow.types';
import { HandoffEditPage } from './handoff-edit-page';
import { HandoffSnapshot } from '../../../handoff-hub.types';

export interface ChecklistHandoffComponentProps {
  handoffId?: string;
  initialNotes: string;
  initialMetrics?: ChecklistMetricItem[];
  isSaving: boolean;
  isSubmitting: boolean;
  onCancel: () => void;
  onSaveAndClose: (notes: string) => void;
  onSubmit: (notes: string, metrics: ChecklistMetricItem[]) => void;
}

export interface ChecklistFlowConfig {
  Component: ComponentType<ChecklistHandoffComponentProps>;
  mapMetrics: (metrics: ChecklistMetricItem[]) => HandoffSnapshot['metrics'];
  getInitialMetrics?: (metrics: HandoffSnapshot['metrics']) => ChecklistMetricItem[];
}

interface Props extends HandoffFlowProps {
  config: ChecklistFlowConfig;
}

export const ChecklistHandoffFlow = ({
  config,
  snapshot,
  isUpdating,
  saveSnapshot,
  onCancel,
  onSubmitSuccess,
  navigateToRoot,
  typeSelector,
}: Props) => {
  const { Component, mapMetrics, getInitialMetrics } = config;
  return (
    <HandoffEditPage snapshot={snapshot} isUpdating={isUpdating}>
      {typeSelector}
      <Component
        handoffId={snapshot.id}
        initialNotes={snapshot.officeExperience ?? ''}
        initialMetrics={getInitialMetrics?.(snapshot.metrics || [])}
        isSaving={isUpdating}
        isSubmitting={isUpdating}
        onCancel={onCancel}
        onSaveAndClose={(notes) =>
          saveSnapshot({ officeExperience: notes }, navigateToRoot)
        }
        onSubmit={(notes, checklistMetrics) =>
          saveSnapshot(
            { officeExperience: notes, metrics: mapMetrics(checklistMetrics) },
            onSubmitSuccess,
            true
          )
        }
      />
    </HandoffEditPage>
  );
};
